module.exports = __webpack_public_path__ + "static/media/user06.ebb775d0.png";